// @flow
import * as React from 'react';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import ButtonIndex from 'components/ButtonIndex';
//import ButtonNextPage from 'components/ButtonNextPage';
import Logo from 'components/Logo';
import {LayoutCenterMiddle} from 'components/Layout';
import {useLocalized} from 'components/Localized';
import GuideMessage from '../course-a/GuideMessage';
//import ButtonSkip from './ButtonSkip';
import GuideStep from '../GuideStep';
import Disclaimer from 'components/Disclaimer'
import ButtonNextPage from 'components/ButtonNextPage';
import SoundToggleButton from 'components/SoundToggleButton';

type Props = {
  onOpenModalIndex: () => void,
  onCloseModalIndex: () => void,
  openModalIndex: boolean,
  onNext: () => void,
  onSkip: () => void,
};

export default function IntroB(props: Props): React.Element<any> {
  const history = useHistory();
  const localized = useLocalized();
  const [page, setPage] = React.useState(0);

  console.log("IntroB:page=", page);
  const {openModalIndex, onNext} = props;
  const handleMoveTo = React.useCallback(
    (url: string) => {
      history.push(`/driving-zone/course-b/${url}`);
    },
    [history]
  );

  const handleNextPage = React.useCallback(() => {
    let nextPage = page + 1;
    if (nextPage === 2) {
        onNext();
    }

    setPage(nextPage);
  }, [page, onNext]);

  React.useEffect(() => {
    window.ready3d(function () {
      const src = (process.env.PUBLIC_URL ?? '') + '/video/B01_1';
      const vr = false;
      const loop = false;
      window.videoPlayer.load(src, vr, loop);
    });
  }, []);
  React.useEffect(()=>{
    window.tagManager.drivingZoneCourseBIntroPage();
  },[]);

  React.useEffect(()=>{
    if (page === 1) {
      window.tagManager.drivingZoneCourseBStepInfoPage();
    }
  },[page]);

  return (
    <main>
      <GuideWrapper onClick={handleNextPage}>
        <LayoutCenterMiddle>
          <GuideMessage
            appear={true}
            enter={false}
            in={page === 0}
            timeout={500}
            guide={localized.driving_b00_index_guide_001}
          />
        </LayoutCenterMiddle>
      </GuideWrapper>
      {page === 1 && <GuideStep
          show={page === 1}
          title={[
            "driving_a00_guide_210426_003",
            "driving_a00_guide_210426_004"
          ]}
          step={[
            "driving_b00_index_guide_011",
            "driving_b00_index_guide_012",
            "driving_b00_index_guide_013",
          ]}
          stepTitle={[
            "driving_b00_index_guide_002",
            "driving_b00_index_guide_003",
            "driving_b00_index_guide_004"
          ]}
          images={[
            "./driving-zone/b/img-step-b-bg-1.jpg",
            "./driving-zone/b/img-step-b-bg-2.jpg",
            "./driving-zone/b/img-step-b-bg-3.jpg"
          ]}
          onStep={[
            ()=>{window.tagManager.stepInfoStep1BClickLinkClick();handleMoveTo("charging-station");},
            ()=>{window.tagManager.stepInfoStep2BClickLinkClick();handleMoveTo("in-car-experience");},
            ()=>{window.tagManager.stepInfoStep3BClickLinkClick();handleMoveTo("driving-experience");}
          ]}
        />}
      {!openModalIndex && <ButtonIndex onOpenModalIndex={props.onOpenModalIndex} />}

      <ButtonNextPage buttons={[{onNext: handleNextPage, title: localized.button_next}]} />
      <Logo />
      <SoundToggleButton />
      {page !== 1 && <Disclaimer textKey="disclaimer_default" />}
      
    </main>
  );
}

const GuideWrapper = styled.button`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
`;
